<template>
<section class="topper flex overflow-hidden items-center justify-center px-4 bg-black relative" :class="wrapper">

    <BackgroundSlider :images="background_images"></BackgroundSlider>

    <div ref="wedge" class="wedge absolute left-0 bottom-0 bg-gray-700 overflow-hidden" aria-hidden="true"></div>
    
    <div class="max-w-6xl mx-auto z-20 w-full">

        <div v-if="format == 'slashes'" class="slash-grid grid">
            <template v-for="(headline, i) in headlines">
                <SmoothLoader :delay="(i * 150)" class="slashed-headline text flex items-center justify-center">
                    <span v-html="headline.text" class="text-white uppercase text-center font-medium tracking-widest text-2xl vt:text-base ht:text-lg"></span>
                </SmoothLoader>
                <SmoothLoader :delay="(i * 150) + 75" v-if="i != headlines.length - 1" class="slash hidden vt:flex items-center justify-center" aria-hidden="true">
                    <div class="slash-line" :style="slashStyle"></div>
                </SmoothLoader>
            </template>
        </div>

        <div v-if="format == 'single'" class="max-w-4xl mx-auto">
            <HeadlineSlider v-if="headline.length && headline.length > 1" :headlines="headline"></HeadlineSlider>

            <SmoothLoader v-if="headline.length === 1" tag="h1" v-html="headline[0]" class="text-center text-white font-medium uppercase tracking-wider text-2xl vt:text-4xl"></SmoothLoader>
            <SmoothLoader v-if="subhead" class="text-gray-400 text-center font-medium" v-html="subhead"></SmoothLoader>
        </div>

        <div v-if="format == 'contact'" class="py-15%">
            <SmoothLoader class="flex flex-wrap ht:items-center -mx-4">
                <div class="w-full ht:w-1/2 px-4 my-12 ht:my-0">
                    <SmoothLoader tag="h1" v-html="headline" class="text-white font-medium uppercase tracking-wider text-2xl vt:text-4xl"></SmoothLoader>
                    <div v-if="blurb" class="prose text-white max-w-sm">
                        <p v-html="blurb"></p>
                    </div>
                </div>
                <div class="w-full ht:w-1/2 px-4" v-if="embed_code">
                    <GravityForm :code="embed_code"></GravityForm>
                </div>
            </SmoothLoader>
        </div>

    </div>

    <div v-if="format == 'single' && height == 'tall'" class="corner block absolute text-gray-400">
        <i class="fa-solid fa-arrow-down text-xl"></i>
    </div>

</section>
</template>

<script>

import BackgroundSlider from '../Utilities/BackgroundSlider.vue';
import HeadlineSlider from '../Utilities/HeadlineSlider.vue';
import GravityForm from '../Utilities/GravityForm.vue';
const $ = window.jQuery;
import { onMounted, onBeforeUnmount, ref, computed } from 'vue';

const rToD = (radians) => {
    return radians * (180/(Math.PI));
}

export default {

    props: ['data'],
    
    setup(props) {

        const wedge = ref(null);
        const line = ref(null);
        let lineStyle = ref('');
        let slashStyle = ref('');

        let onResize;

        onMounted(() => {

            const getLineRotation = () => {

                let $wedge = $(wedge.value);

                let a = $wedge.outerHeight();
                let b = $wedge.outerWidth() / 2;
                let c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

                let sineOfAngle = a / c;
                let radians = Math.asin(sineOfAngle);
                let degrees = rToD(radians) - 90;

                return {
                    rotation: degrees,
                    height: Math.ceil(c)
                };

            };

            onResize = () => {
                let geometry = getLineRotation();
                lineStyle.value = `transform: rotate(${geometry.rotation}deg); height: ${geometry.height}px;`;
                slashStyle.value = `transform: rotate(${geometry.rotation}deg);`;
            };

            onResize();

            $(window).on('resize', onResize);

        });

        onBeforeUnmount(() => {
            $(window).off('resize', onResize);
        });

        const wrapper = computed(() => {
            let output = props.data.height + ' ' + props.data.format;
            if (props.data.headline.length > 1) {
                output = output + ' with-text-slider';
            }
            if (props.data.headline.some(title => title.length >= 60)) {
                output = output + ' long-headline';
            }
            return output;
        });

        return {
            lineStyle,
            slashStyle,
            wedge,
            wrapper,
            ...props.data
        }
        
    },

    components: {
        BackgroundSlider,
        HeadlineSlider,
        GravityForm
    }

}
</script>